import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b376a9a6")

_pushScopeId("data-v-b376a9a6")
const _hoisted_1 = { id: "viewSettings" }
const _hoisted_2 = { class: "settings-row" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "label" }, "View ID", -1)
const _hoisted_4 = { class: "settings-row" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "label" }, "Target ID", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" This action will make the specified "),
  /*#__PURE__*/_createVNode("i", null, "view"),
  /*#__PURE__*/_createTextVNode(" display the specified "),
  /*#__PURE__*/_createVNode("i", null, "target"),
  /*#__PURE__*/_createTextVNode(" for this player. ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "componentIdInput",
        onFocus: _cache[1] || (_cache[1] = $event => (_ctx.idWatcher = val => (_ctx.action.targetId = val))),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.action.targetId = $event))
      }, null, 544), [
        [_vModelText, _ctx.action.targetId]
      ])
    ]),
    _createVNode("p", {
      class: ["label", 
        _ctx.components[_ctx.action.targetId] &&
        _ctx.components[_ctx.action.targetId].displayName == 'View'
          ? ''
          : 'red-text'
      ]
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.action.targetId]
          ? " NOT FOUND!"
          : _ctx.components[_ctx.action.targetId].displayName != "View"
          ? " is not a View"
          : ": " + _ctx.components[_ctx.action.targetId].name), 3),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "componentIdInput",
        onFocus: _cache[3] || (_cache[3] = $event => (_ctx.idWatcher = val => (_ctx.action.activate = val))),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.action.activate = $event))
      }, null, 544), [
        [_vModelText, _ctx.action.activate]
      ])
    ]),
    _createVNode("p", {
      class: ["label", _ctx.components[_ctx.action.activate] && _ctx.isChild() ? '' : 'red-text']
    }, " TARGET" + _toDisplayString(!_ctx.components[_ctx.action.activate]
          ? " NOT FOUND!"
          : !_ctx.isChild()
          ? "is not a direct child of view"
          : ": " + _ctx.components[_ctx.action.activate].name), 3),
    _hoisted_6
  ]))
})